import { render, staticRenderFns } from "./toprintForGood.vue?vue&type=template&id=5077ad26&scoped=true&"
import script from "./toprintForGood.vue?vue&type=script&lang=js&"
export * from "./toprintForGood.vue?vue&type=script&lang=js&"
import style0 from "./toprintForGood.vue?vue&type=style&index=0&id=5077ad26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077ad26",
  null
  
)

export default component.exports